import { abortSmartOnboardingApi as generatedAbortSmartOnboardingApi } from '../generated/onboarding/abortSmartOnboarding';

const abortSmartOnboardingApi = generatedAbortSmartOnboardingApi.enhanceEndpoints({
  endpoints: {
    abortSmartOnboarding: {
      invalidatesTags: ['Onboard'],
    },
  },
});

export const { useAbortSmartOnboardingMutation } = abortSmartOnboardingApi;
